export enum AccountLevelGovBrEnum {
    BRONZE = "1",
    PRATA = "2",
    OURO = "3"
} 